import {useRef, useState} from "react";
import Confirm from "./Confirm";

export function useConfirm() {
  const resolverRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [saving, setSaving] = useState(false);

  const confirm = (config) =>
    new Promise((resolve) => {
      resolverRef.current = resolve;
      setConfirmation(config);
      setOpen(true);
    });

  const handleConfirm = (value = true) => {
    resolverRef.current(value);
    cleanup();
  };

  const handleCancel = () => {
    resolverRef.current(false);
    cleanup();
  };

  const cleanup = () => {
    resolverRef.current = null;
    setConfirmation(null);
    setOpen(false);
  };

  const ConfirmationDialog = () => {
    if (!open || !confirmation) return null;

    return (
      <Confirm confirmation={confirmation}
               show={open}
               saving={saving}
               handleConfirm={handleConfirm}
               handleClose={handleCancel}
               handleSave={handleCancel} />
    );
  };

  return { confirm, ConfirmationDialog };
}

